"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tutorial = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var React = __importStar(require("react"));
var Divider_1 = require("../Divider/Divider");
var FlexView_1 = require("../FlexView/FlexView");
var Hyperlink_1 = require("../Hyperlink/Hyperlink");
var Image_1 = require("../Image/Image");
var Title_1 = require("../Title/Title");
var OkInch_1 = require("./OkInch");
require("./tutorial.css");
var Tutorial = /** @class */ (function (_super) {
    __extends(Tutorial, _super);
    function Tutorial() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.setMarginTop = function () {
            var cards = Array.from(document.querySelectorAll('.tutorial-cards .tutorial-card')).map(function (element) {
                element.style.marginTop = '0px';
                return element;
            });
            if (window.outerWidth < 769) {
                return;
            }
            cards.reduce(function (lastHeight, element, index) {
                if (index === 1) {
                    element.style.marginTop = "".concat((lastHeight / 5) * 3, "px");
                }
                else if (index % 2 === 0) {
                    element.style.marginTop = "".concat((-lastHeight / 5) * 2, "px");
                }
                else {
                    element.style.marginTop = "".concat(lastHeight / 6, "px");
                }
                return element.clientHeight;
            }, 0);
            _this.activateTutorialCards();
        };
        _this.activateTutorialCards = function () {
            var _a;
            var threshold = ((_a = document.documentElement) === null || _a === void 0 ? void 0 : _a.clientHeight) * 0.5;
            var cards = Array.from(document.querySelectorAll('.tutorial-cards .tutorial-card'));
            var okCircle = document.querySelectorAll('.tutorial-footer').item(0);
            var deactivated = cards.reduce(function (deactivatedCards, card, index) {
                if (index === 0) {
                    card.style.opacity = '1';
                    return deactivatedCards - 1;
                }
                if (card.getBoundingClientRect().top <= threshold && window.pageYOffset > 0) {
                    card.style.opacity = '1';
                    return deactivatedCards - 1;
                }
                card.style.opacity = '0.25';
                return deactivatedCards;
            }, cards.length);
            okCircle.style.opacity = deactivated === 0 ? '1' : '0.25';
        };
        return _this;
    }
    Tutorial.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.setMarginTop);
        document.addEventListener('shark-image-load', this.setMarginTop);
        window.addEventListener('scroll', this.activateTutorialCards);
    };
    Tutorial.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.setMarginTop);
        document.removeEventListener('shark-image-load', this.setMarginTop);
        window.removeEventListener('scroll', this.activateTutorialCards);
    };
    Tutorial.prototype.renderBackLink = function () {
        return ((0, jsx_runtime_1.jsxs)(FlexView_1.FlexView, { children: [(0, jsx_runtime_1.jsx)(FlexView_1.FlexView.Item, { grow: true }), (0, jsx_runtime_1.jsx)(FlexView_1.FlexView.Item, { children: (0, jsx_runtime_1.jsx)(Hyperlink_1.Hyperlink, { type: "click", label: "Torna Indietro", borderless: true, arrowSide: "left-side", onClick: function () { return window.history.back(); } }) })] }));
    };
    Tutorial.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "tutorial" }, { children: [(0, jsx_runtime_1.jsx)(Title_1.Title, __assign({ tag: "h1" }, { children: this.props.config.title })), (0, jsx_runtime_1.jsx)(Divider_1.Divider, {}), this.renderBackLink(), (0, jsx_runtime_1.jsx)("div", __assign({ className: "tutorial-cards" }, { children: this.props.config.steps.map(function (step, index) { return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "tutorial-card" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "tutorial-card-i" }, { children: (0, jsx_runtime_1.jsx)("div", { children: index + 1 }) })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "tutorial-card-content" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "tutorial-card-image" }, { children: (0, jsx_runtime_1.jsx)(Image_1.Image, { src: step.image }) })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "tutorial-card-footer" }, { children: [(0, jsx_runtime_1.jsx)("span", { children: step.title }), (0, jsx_runtime_1.jsx)("p", { children: step.content })] }))] }))] }), index)); }) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "tutorial-footer" }, { children: (0, jsx_runtime_1.jsx)(OkInch_1.OkInch, {}) }))] })));
    };
    return Tutorial;
}(React.PureComponent));
exports.Tutorial = Tutorial;
//# sourceMappingURL=Tutorial.js.map